import "./HomeContent.css";
export default function HomeContent() {
  return (
    <>
      <div className="px-lg-4 mt-2 pt-1 home-content-page">
        <div className="container-fluid px-lg-3">
          <div className="row">
            <div className="col-12">
              <h2>Trusted Beverage Suppliers and Distributors Since 1962</h2>
              <p>
                We have been serving fresh and tasty beverages since 1962. With
                years of experience, we understand what people love to drink.
                Our wide range of fruit juices and milk-based drinks is made
                with care and clean methods. We always focus on quality,
                freshness, and taste. From a single bottle to bulk delivery, we
                make sure each drink is safe and ready to enjoy.
              </p>
              <p>
                We work closely with{" "}
                <a href="https://rubyfood.com/ct/beverages/1/1">
                  beverage suppliers
                </a>{" "}
                and distributors to deliver drinks across Tamil Nadu and South
                India. Our team is dedicated to providing you with the best
                service, delivered on time and with full safety. Whether you
                want fruity drinks like Zappy and Mango Juice or traditional
                milkshakes like Rose Milk and Badam Milk, we have it all. We
                proudly support local distributors with trusted beverages that
                people enjoy every day.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h2>
                South India's Beverage Distributor: Juice & Soft Drink
                Manufacturer in Tamil Nadu
              </h2>
              <p>
                We are proud to be a top South Indian beverage distributor and
                juice & soft drink manufacturer in Tamil Nadu. Our drinks are
                made in a modern, clean facility using quality ingredients. From
                fruit juices to classic milk drinks, everything is made with
                love and care. We offer popular drinks like Zappy Apple, Mango
                Juice, Mr. Coco, and Sparkly Blueberry. For those who love milk
                drinks, we have Rose Milk, Badam Milk, and Jigarthanda Milk. Our
                goal is to bring the real taste of South India in every bottle.
                We supply beverages to distributors across the region, helping
                them serve shops, events, and more.{" "}
              </p>
              <p className="d-lg-block d-none">
                {" "}
                Our mission is to deliver fresh, safe, and tasty drinks that
                everyone can enjoy. With strong supply chains and trusted
                products, we are one of the best choices for beverages in Tamil
                Nadu.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h2>
                Beverage Wholesalers in Madurai - Best Bulk Drink Suppliers Near
                You
              </h2>
              <p>
                As one of the leading beverage wholesalers in Madurai, we supply
                a wide range of drinks in bulk. Whether you need fruit juices or
                milkshakes, we provide fresh products with quick delivery. Our
                drinks are perfect for{" "}
                <a href="https://rubyfood.com/distributor">distributors</a> who
                supply to local shops, restaurants, and events. We offer{" "}
                <a href="https://rubyfood.com/ct/combos/1/3">combos</a> and bulk
                deals on favorites like Zappy, Mango Drink, Rose Milk, Badam
                Milk, and many more. Every product is made with clean methods
                and packed safely. Our team works closely with wholesalers to
                make sure every delivery is smooth and on time.
              </p>
              <p className="d-lg-block d-none">
                If you're looking for the best bulk drink suppliers near you, we
                are ready to serve with quality, freshness, and great value. We
                make sure that our partners get the best products that customers
                love.
              </p>
            </div>
            <div className="col-12 mt-3">
              <h2>No.1 Selling Cold Drink in India</h2>
              <p>
                Ruby Food is proud to offer the No.1 selling cold drinks loved
                by customers across India. We offer high-quality soft drinks and
                milkshakes at affordable prices. All our products are made with
                natural ingredients and are full of flavor. Every drink is made
                in our safe and modern facility to keep freshness and taste in
                every sip. We work with distributors and wholesalers across
                India to make sure our products reach every corner. People
                choose Ruby Food not just for the taste, but also for the trust.
                With clean production, quality ingredients, and great flavors,
                our drinks are loved by families, students, and workers alike.
                We are happy to be known as one of the top names in the beverage
                industry.
              </p>
            </div>

            <div className="col-12 mt-3 d-lg-block d-none">
              <h2>
                Beverage Supplier & Distributors Near Me - Fast and Reliable
                Drink Delivery
              </h2>
              <p>
                Looking for a beverage supplier & distributors near me? Trusted
                local distributors make it easy to get fresh and tasty drinks
                quickly. They offer a wide range of beverages, including badam
                milk, rose milk, fruit juices, and soft drinks, for shops,
                schools, offices, and events.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
